module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业时间"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '00:00',
        step: '00:01',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '00:00',
        step: '00:01',
        end: '24:00',
        minTime: _vm.startTime
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("24小时制，如10：00-20：30")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺英克ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入店铺英克ID，多个ID使用换行分割",
      "rows": 15
    },
    model: {
      value: (_vm.form.distributor_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_ids", $$v)
      },
      expression: "form.distributor_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.updateStoreOperatingTime
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13617c8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13617c8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/operating_time.vue
// module id = 2483
// module chunks = 0